import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { I18nBreadcrumb } from '@/components/ui/i18breadcrumb';
import { ImageToVideoPage } from '@/pages/image-to-video';

export const Route = createFileRoute('/_authenticated/_sidebar-layout/image-to-video')({
  component: ImageToVideoPage,
  validateSearch: zodValidator(
    z.object({
      imageId: z.string().optional(),
      estateId: z.string().optional(),
      projectId: z.string().optional(),
    })
  ),
  staticData: { breadcrumb: () => <I18nBreadcrumb translationKey="image-to-video" /> },
});
